module.exports = __webpack_public_path__ + "img/arrow_up.756d5c3b.svg";